import { PropertyHelper } from '../../helpers/PropertyHelper';
import { IProperty } from '../../interfaces/Property';
import {
	createNewProperty,
	createUrlSetAndUpdateProperty,
	updateProperty
} from '../../services/PropertiesService';

export interface SavePropertyParams {
	draft: IProperty;
	propertyId: string;
	shouldCrawl: boolean;
	isListMode: boolean;
}

/**
 * Decision tree:
 *   New property (draft mode)               → createNewProperty(draft, shouldCrawl, isListMode)
 *   Existing property + list mode or crawl  → createUrlSetAndUpdateProperty(draft, isListMode)
 *   Existing property + no crawl            → updateProperty(draft)
 */
export async function savePropertyDraft({
	draft,
	propertyId,
	shouldCrawl,
	isListMode
}: SavePropertyParams): Promise<IProperty> {
	if (PropertyHelper.isPropertyInDraftMode(propertyId)) {
		return createNewProperty(draft, shouldCrawl, isListMode);
	}

	if (isListMode || shouldCrawl) {
		return createUrlSetAndUpdateProperty(draft, isListMode);
	}

	return updateProperty(draft);
}
